import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState, useRef, forwardRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styled, { useTheme, css } from 'styled-components';
import { Box } from '@yoweb/ui/components/Box';
import { th } from '@yoweb/ui/styles/utils/theme';
import { pxToRem, media } from '@yoweb/ui/styles/utils';
import { Flyout } from '@poplar/components/Flyout';
import { FlyoutClose } from '@poplar/components/Flyout/FlyoutClose';
import { Title, Label } from '@yoweb/ui/components/typography';
import { Content, FlyoutHeader, FlyoutLayout, FlyoutTitle, HeaderContainer, FlyoutHeroHeader } from './common';
import { FlyoutBack } from '@poplar/components/Flyout/FlyoutBack';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
// Buffer on when to start shrinking the header, useful when screens close to the threshold
var SCROLL_BUFFER = 40;
/**
 * Flyout for the todo type selection
 */

export var FlyoutTodoLayout = function FlyoutTodoLayout(_ref) {
  var title = _ref.title,
      description = _ref.description,
      _ref$descriptionSize = _ref.descriptionSize,
      descriptionSize = _ref$descriptionSize === void 0 ? 'bodyMd' : _ref$descriptionSize,
      backgroundColor = _ref.backgroundColor,
      closeButton = _ref.closeButton,
      headerBackgroundColor = _ref.headerBackgroundColor,
      children = _ref.children,
      header = _ref.header,
      dataTestId = _ref['data-testid'],
      onClose = _ref.onClose,
      onScrollToBottom = _ref.onScrollToBottom;

  var _useState = useState(false),
      isHeaderCompact = _useState[0],
      setIsHeaderCompact = _useState[1];

  var _useState2 = useState(false),
      isScrolled = _useState2[0],
      setIsScrolled = _useState2[1];

  var headerElementRef = useRef(null);
  var theme = useTheme();

  var onScroll = function onScroll(e) {
    var _headerElementRef$cur;

    var headerHeight = (_headerElementRef$cur = headerElementRef.current) === null || _headerElementRef$cur === void 0 ? void 0 : _headerElementRef$cur.clientHeight;
    var scrollPosition = e.currentTarget.scrollTop;
    var scrollHeight = e.currentTarget.scrollHeight;
    var clientHeight = e.currentTarget.clientHeight;

    if (scrollPosition > 0) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    } // Sometimes off by half a pixel


    if (clientHeight === Math.floor(scrollHeight - scrollPosition)) {
      onScrollToBottom === null || onScrollToBottom === void 0 ? void 0 : onScrollToBottom();
    }

    if (scrollPosition > 0) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }

    if (headerHeight && scrollPosition > headerHeight + SCROLL_BUFFER) {
      setIsHeaderCompact(true);
    } else {
      setIsHeaderCompact(false);
    }
  };

  var fontStylesExpanded = {
    fontSize: theme.fontSizes.titleMd,
    lineHeight: theme.lineHeights.titleMd,
    letterSpacing: theme.letterSpacing.titleMd
  };
  var fontStylesCompact = {
    fontSize: theme.fontSizes.interactiveSm,
    lineHeight: theme.lineHeights.interactiveSm,
    letterSpacing: theme.letterSpacing.interactiveSm
  };
  return /*#__PURE__*/_jsxs(FlyoutLayout, {
    "data-testid": dataTestId,
    backgroundColor: backgroundColor,
    children: [/*#__PURE__*/_jsxs(FlyoutHeader, {
      ref: headerElementRef,
      $isCompact: isHeaderCompact,
      backgroundColor: headerBackgroundColor,
      pb: header ? 'normal2' : undefined,
      $showBoxShadow: isScrolled,
      children: [/*#__PURE__*/_jsxs(Box, {
        children: [/*#__PURE__*/_jsx(HeaderContainer, {
          $isCompact: isHeaderCompact,
          children: /*#__PURE__*/_jsx(FlyoutTitle, {
            $textTransform: isHeaderCompact ? 'uppercase' : null,
            initial: _objectSpread(_objectSpread({}, fontStylesExpanded), {}, {
              x: '0'
            }),
            animate: _objectSpread(_objectSpread({}, isHeaderCompact ? fontStylesCompact : fontStylesExpanded), {}, {
              x: isHeaderCompact ? '-50%' : '0%'
            }),
            transition: {
              type: 'linear',
              duration: 0.3
            },
            children: title
          })
        }), /*#__PURE__*/_jsx(AnimatePresence, {
          children: !isHeaderCompact && /*#__PURE__*/_jsx(Description, {
            initial: {
              marginTop: 0,
              opacity: 0,
              fontSize: 0
            },
            animate: {
              opacity: 1,
              marginTop: theme.space.small3,
              fontSize: theme.fontSizes[descriptionSize]
            },
            exit: {
              marginTop: 0,
              opacity: 0,
              fontSize: 0
            },
            transition: {
              type: 'linear',
              duration: 0.3
            },
            children: description
          }, "flyout-description")
        }), /*#__PURE__*/_jsx(Box, {
          mt: isHeaderCompact ? 'normal4' : 'normal1',
          children: header
        })]
      }), closeButton !== null && closeButton !== void 0 ? closeButton : /*#__PURE__*/_jsx(FlyoutClose, {
        onClose: onClose
      })]
    }), /*#__PURE__*/_jsx(Box, {
      position: "relative",
      height: "100%",
      children: /*#__PURE__*/_jsx(Content, {
        onScroll: onScroll,
        $paddingTop: header ? 'none' : undefined,
        "data-testid": "flyout-todo-content",
        children: children
      })
    })]
  });
};
var HeroContentWrapper = styled.div.withConfig({
  componentId: "sc-1w7rw18-0"
})(["margin-bottom:-", ";"], th.getSpace('large1'));
var CompactHeroContentWrapper = styled.div.withConfig({
  componentId: "sc-1w7rw18-1"
})(["margin-top:-", ";"], th.getSpace('xl1'));
/**
 * Flyout page for sub-category details, with featured to-dos
 */

export var FlyoutHeroLayout = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var title = _ref2.title,
      heroImage = _ref2.heroImage,
      children = _ref2.children,
      dataTestId = _ref2['data-testid'],
      onBack = _ref2.onBack,
      onClose = _ref2.onClose,
      heroHeaderContent = _ref2.heroHeaderContent;

  var _useState3 = useState(false),
      isHeaderCompact = _useState3[0],
      setIsHeaderCompact = _useState3[1]; // On scroll, set header to compact.  Reversal is much more complicated and will need more care and exploration.


  var handleOnScroll = function handleOnScroll(e) {
    var scrollTop = e.currentTarget.scrollTop;

    if (scrollTop > 0) {
      setIsHeaderCompact(true);
    }
  };

  return /*#__PURE__*/_jsxs(FlyoutLayout, {
    "data-testid": dataTestId,
    ref: ref,
    children: [/*#__PURE__*/_jsxs(FlyoutHeroHeader, {
      heroImage: heroImage,
      isCompact: isHeaderCompact,
      children: [isHeaderCompact ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Box, {
          height: "100%",
          display: "grid",
          alignContent: "start",
          maxWidth: "100vw",
          children: /*#__PURE__*/_jsx(Box, {
            py: "normal3",
            position: "relative",
            backgroundColor: "base000",
            children: /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(Label, {
                size: "sm",
                textAlign: "center",
                children: title
              })
            })
          })
        }), /*#__PURE__*/_jsx(Box, {
          children: /*#__PURE__*/_jsx(Box, {
            position: "relative",
            height: "100%",
            children: /*#__PURE__*/_jsx(CompactHeroContentWrapper, {
              children: heroHeaderContent
            }, "feature-cards-header")
          })
        })]
      }) : /*#__PURE__*/_jsxs(Box, {
        display: "grid",
        alignContent: "end",
        minHeight: "100%",
        children: [/*#__PURE__*/_jsx(Box, {
          position: "relative",
          pt: {
            _: 'large1',
            md: 'large3'
          },
          pl: "normal1",
          pb: "normal1",
          children: /*#__PURE__*/_jsx(Title, {
            variant: "inverse",
            children: title
          })
        }), /*#__PURE__*/_jsx(Box, {
          position: "relative",
          height: "100%",
          children: /*#__PURE__*/_jsx(HeroContentWrapper, {
            children: heroHeaderContent
          }, "feature-cards-header")
        })]
      }), onBack && /*#__PURE__*/_jsx(FlyoutBack, {
        onClick: onBack
      }), /*#__PURE__*/_jsx(FlyoutClose, {
        onClose: onClose
      })]
    }), /*#__PURE__*/_jsx(Box, {
      position: "relative",
      height: "100%",
      children: /*#__PURE__*/_jsx(FlyoutHeroLayoutContent, {
        extraMarginTop: !!heroHeaderContent,
        onScroll: handleOnScroll,
        "data-testid": "flyout-hero-content",
        children: children
      })
    })]
  });
});
FlyoutHeroLayout.displayName = 'FlyoutHeroLayout';
export var FlyoutTodo = function FlyoutTodo(_ref3) {
  var title = _ref3.title,
      description = _ref3.description,
      isOpen = _ref3.isOpen,
      onClose = _ref3.onClose,
      children = _ref3.children;
  return /*#__PURE__*/_jsx(Flyout, _defineProperty({
    isOpen: isOpen,
    onClose: onClose,
    children: children
  }, "children", /*#__PURE__*/_jsx(FlyoutTodoLayout, {
    title: title,
    description: description,
    onClose: onClose,
    children: children
  })));
};
var Description = styled(motion.p).withConfig({
  componentId: "sc-1w7rw18-2"
})(["line-height:", ";letter-spacing:", ";"], th.getLineHeight('bodyMd'), th.getLetterSpacing('bodyMd'));
var FlyoutHeroLayoutContent = styled(Content).withConfig({
  componentId: "sc-1w7rw18-3"
})(["&&{", ";", "}"], function (_ref4) {
  var extraMarginTop = _ref4.extraMarginTop;
  return extraMarginTop && css(["margin-top:", ";"], pxToRem(75));
}, media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      ", ";\n    "])), function (_ref5) {
  var extraMarginTop = _ref5.extraMarginTop;
  return extraMarginTop && css(["margin-top:", ";"], pxToRem(55));
}));